/*
*   重复请求 名单
*   request.js 中配置了 全局的重复请求取消，如果新请求跟上一次请求 URL 和 method 一样，则取消上一次请求
*   如果需要过滤重复请求，请参考下面配置-----------一定记得注释
*
*
* */

// 默认配置 主界面的 查询接口
const whiteRequestUrl = [

    // 产品
    [
        // 产品管理 - 产品资料
        '/supply/product/page',

        // 产品管理 - 品类资料
        '/supply/category/page',
    ],
    // 销售
    [
        // 商品 - listing
        '/operation/listing',

        // 商品 - review
        '/crm/review',

        // 商品 - Feedback
        '/crm/feedback',

        // 商品 - 运营日志
        '/operation/operationLog/page',

        // 订单 - 销售订单
        '/operation/order',

        // 订单 - 推广订单
        '/operation/testOrder',

        // 数据报告 - 退货报告
        '/operation/customerReturn/page',

        // 数据报告 - 换货报告
        '/operation/replacementOrder/page',

        // 数据报告 - 配送报告
        '/operation/amazonShipment/page',

        // 数据报告 - 移除报告
        '/operation/removalShipment/page',

        // review - review详情
        '/crm/review/${id}/detail',

        // review - review详情匹配订单列表
        '/crm/review/${id}/matchOrderList'
    ],
    // 采购
    [
        // 采购管理 - 采购计划
        '/supply/purchasePlan/page',

        // 采购订单 - 采购订单
        '/supply/purchaseOrder/page',

        // 采购管理 - 交货单
        '/supply/purchaseDeliveryNote/page',

        // 采购订单 - 采购变更单
        '/supply/purchaseOrderChange/page',

        // 基础配置 - 供应商资料
        '/supply/supplier/page',
    ],
    // 仓库
    [
        // 库存管理 - 产品库存
        '/supply/productInventory/productPage',

        // 库存管理 - FBA库存
        '/supply/storage/fbaPage',

        // 库存管理 - 库存库存
        '/supply/warehouseInventory/page',

        // 库存操作 - 采购入库单
        '/supply/purchaseOrderChange/page',

        // 库存操作 - 调拨单
        '/supply/transfer/page',

        // 库存操作 - 装配单
        '/supply/assemble/page',

        // 库存操作 - 盘点单
        '/supply/storageCheck/page',

        // 库存操作 - 出入库记录
        '/supply/inbound/page',

        // 库存操作 - 成本补录
        '/supply/costSupplement/page',

        // 基础配置 - 仓库资料
        '/supply/warehouse/page',
    ],
    // 物流
    [
        // 发货管理 - 发货计划
        '/supply/purchasePlan/page',

        // 发货管理 - FBA货件
        '/supply/shipment/page',

        // 发货管理 - 发货单
        '/supply/shipNote/page',

        // 基础配置 - 物流商资料
        '/supply/logistics/page',
    ],
    // 广告
    [
        // 广告管理 - 关键词
        '/ads/keywordRank/checkAsin',
        // 广告管理 - 商品广告 - 广告活动
        '/ads/adsSpCampaigns/page',

        // 广告管理 - 商品广告 - 广告活动
        '/ads/adsSpGroups/page',

        // 广告管理 - 商品广告 - 商品
        '/ads/adsSpProduct/page',

        // 广告管理 - 商品广告 - 关键词
        '/ads/adsSpKeywords/page',

        // 广告管理 - 商品广告 - 否定关键词
        '/ads/adsSpCampaignNegativeKeywords/page',

        // 广告管理 - 商品广告 - 商品投放
        '/ads/adsSpProductTargeting/page',

        // 广告管理 - 商品广告 - 否定商品投放
        '/ads/adsSpNegativeProductTargeting/page',

        // 广告管理 - 商品广告 - 投放组
        '/ads/adsSpProductTargeting/page',

        // 广告管理 - 商品广告 - 用户搜索词
        '/ads/adsSpSearchKeywordsReport/page',

        // 广告管理 - 展示广告 - 广告活动
        '/ads/adsSdCampaigns/page',

        // 广告管理 - 展示广告 - 广告组
        '/ads/adsSdGroups/page',

        // 广告管理 - 展示广告 - 商品
        '/ads/adsSdProduct/page',

        // 广告管理 - 展示广告 - 商品投放
        '/ads/adsSdTargeting/page',

        // 广告管理 - 展示广告 - 否定商品投放
        '/ads/adsSdNegativeTargeting/page',

        // 广告管理 - 品牌广告 - 广告活动
        '/ads/adsSbCampaigns/page',

        // 广告管理 - 品牌广告 - 关键词
        '/ads/adsSbKeywords/page',

        // 广告管理 - 品牌广告 - 否定关键词
        '/ads/adsSbNegativeKeywords/page',

        // 广告管理 - 品牌广告 - 商品投放
        '/ads/adsSbProductTargeting/page',

        // 广告管理 - 品牌广告 - 否定商品投放
        '/ads/adsSbNegativeProductTargeting/page',

        // 广告工具 - 分时策略
        '/ads/adsStrategyTemplate/page',

        // 广告工具 - 调整日志
        '/ads/adsStrategyObjectLog/page',

        // 广告分析 - asin分析
        '/ads/adsAsinPerformance/page',

        // 广告分析 - 热词分析
        '/ads/adsKeywordPerformance/page',

        // 广告分析 - 实搜索词分析
        '/ads/adsSearchKeywordPerformance/page',
    ],
    // 客服
    [
        // 品控 - 标签管理
        '/crm/tag/tagList',

        // 客户 - 邮件回复
        '/crm/ticket',
        '/crm/ticket/ticketQuantity?marketId',  // 邮件回复详情
        '/operation/order/relatedOrder?marketId',  // 订单详情
        '/crm/ticket/buyerEmailDetail/${id}',  // 邮件内容详情

        // Request a Review - 请求规则
        '/crm/requestRule',

        // Request a Review - 请求记录
        '/crm/requestRecord',
    ],
    // 财务
    [
        // 利润报表 - 利润报表 - msku - ASIN - 父ASIN - sku - 品类 - 店铺
        '/finance/financialProfitAnalysis/analysisStatistics',
        '/finance/financialProfitAnalysis/financialAnalysisList',

        // 利润报表 - 利润报表 - 按月度
        '/finance/financialProfitAnalysis/monthList',

        // 利润报表 - 利润报表 - 结算明细
        '/finance/financialProfitAnalysis/detailsList',

        // 利润报表 - 业绩报告
        '/finance/financialPerformanceReport/queryChargePerformanceReportResultList',

        // 利润报表 - 回款报告
        '/finance/financialPayBack/selectList',

        // 成本管理 - 成本中心
        '/finance/financialMonthCost/fbaMonthCostPage',

        // 成本管理 - 批次管理
        '/supply/storageCostBatch/page',

        // 成本管理 - 扣减记录
        '/supply/storageCostBatchConsume/page',
    ],

    // 分析
    [
        // 运营分析 - 全店铺看板
        '/operation/storeOperation/profitProfile',
        '/operation/storeOperation/comprehensive/overviewAndPie',
        '/operation/storeOperation/comprehensive/lineChart',
        '/operation/storeOperation/sale/indexDetail',
        '/operation/storeOperation/sale/orderDistributed',
        '/operation/storeOperation/sale/orderAreaDistributed',
        '/ads/statistics/analysis/market',
        '/ads/statistics/analysis/market/type',
        '/ads/statistics/analysis/ads/info',
        '/operation/storeOperation/feeDetails',
        '/crm/storeOperation/reviewAnalyse',
        '/crm/storeOperation/reviewChart',
        '/operation/performance',
        '/crm/storeOperation/reviewAnalyse',
        '/crm/storeOperation/reviewChart',

        // 运营分析 - ASIN看板
        '/operation/asin361/asins',

        // 销售分析 - 商品表现
        '/operation/listingAnalyze/show/page',

        // 销售分析 - 商品统计
        '/operation/listingAnalyze/statistics/page',

        // 销售分析 - 产品表现
        '/operation/skuAnalyze/show/page',

        // 销售分析 - 店铺表现
        '/operation/storeAnalyze/show/page',

        // 销售分析 - 店铺统计
        '/operation/storeAnalyze/statistics/page',

        // 销售分析 - 利润统计
        '/operation/profitStatistics/page',

        // 亚马逊报表 - 赔偿
        '/operation/reimbursement/page',

        // 亚马逊报表 - 盘库
        '/operation/inventoryAdjustments/page',

        // 亚马逊报表 - 月度仓储费
        '/operation/storageFee/page',

        // 亚马逊报表 - 长期仓储费
        '/operation/longStorageFee/page',

        // 亚马逊报表 - FBA补货
        '/operation/fbaRestock/page',
    ],
    // 工具
    [
        // 运营工具 - 跟卖监控
        '/operation/offerMonitor',

        // 运营工具 - 索赔助手
        '/operation/claim/page',

        // 运营工具 - 积加云助手
        '/amz/pluginOnlineStatus/page',

        // 运营工具 - 报表助手
        '/amz/reportCreateTask/page',
    ],
    // 系统
    [
        // 权限管理 - 用户管理
        '/authority/user/page',

        // 权限管理 - 角色管理
        '/authority/user/page',

        // 店铺管理 - 店铺授权
        '/base/market/dataGrid',
    ]
]

export const  urlList = whiteRequestUrl.flat(3);
